import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import axios from 'axios';
import Loader from '../../../shared/Loader';
import BackButton from '../../../shared/BackButton';
import { Stack } from '../../../shared/layouts';
import { useMediaQuery } from '@dnhb/node_package';
import { useTheme } from '@emotion/react';
import { useState } from 'react';
import DetailsCard from './DetailsCard';
import PackageCard from './PackageCard';

export default () => {
  const { t } = useTranslation();
  const { type, id } = useParams();
  const navigate = useNavigate();
  const [selectedSubInsurance, setSelectedSubInsurance] = useState(null);
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );

  const { isLoading, data: { data: insurance = [] } = {} } = useQuery(
    `insurances-${type}-${id}`,
    async () =>
      await axios
        .get(`/insurances/products/${type}/${id}`)
        .catch((e) => console.error(e))
  );

  // Fetch contract documents independently
  const { data: contractDocuments } = useQuery(
    `insurances-${type}-${id}-contract-documents`,
    async () =>
      await axios
        .get(`/insurances/products/${type}/${id}/contract-documents`)
        .catch((e) => console.error(e))
  );

  const handleBackClick = () => {
    navigate('/products/insurances', {
      state: { fromDetailPage: true }
    });
  };

  const title = `${insurance.company || ''} ${
    insurance.description || t('Verzekeringspakket')
  }`;

  return (
    <Stack space="xl" width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}>
      {isLoading && <Loader />}
      {selectedSubInsurance !== null ? (
        <>
          <BackButton onClick={() => setSelectedSubInsurance(null)}>
            {t('Terug')}
          </BackButton>
          <DetailsCard
            title={title}
            insuranceData={insurance.sub_insurances[selectedSubInsurance]}
            connectedFiles={insurance.connected_files ?? []}
            isMinDesktop={isMinDesktop}
          />
        </>
      ) : (
        <>
          <BackButton onClick={handleBackClick}>
            {t('Terug')}
          </BackButton>
          <PackageCard
            title={title}
            insurance={insurance}
            connectedFiles={insurance.connected_files ?? []}
            externalFiles={contractDocuments?.data ?? []}
            isMinDesktop={isMinDesktop}
            onSubInsuranceClick={(index) => {
              setSelectedSubInsurance(index);
            }}
          />
        </>
      )}
    </Stack>
  );
};
